import Cookie from '@wetransfer/concorde-cookie';

import { getCookieDomain } from '@helper/cookies';

export const init = () => {
  // Configure Cookie
  Cookie.configure({
    path: '/',
    domain: getCookieDomain(),
    secure: location.protocol === 'https:',
  });
};
